var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "generic_payload_view"
  }, [!_vm.isError ? [_c('div', {
    staticClass: "generic_view"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  })])] : [_c('p', [_vm._v("Failed to load generic collectible payload.")])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }